import React from "react"
import MuiSkeleton, { SkeletonProps } from "@mui/material/Skeleton"

const Skeleton: React.FC<SkeletonProps> = ({ children, ...props }) => (
  <MuiSkeleton {...props}>{children}</MuiSkeleton>
)

export default Skeleton
